import React from 'react';
import {
  Box,
  VStack,
  HStack,
  Text,
} from '@chakra-ui/react';
import { ContactInfoItemProps } from '../types';

const ContactInfoItemPresentation: React.FC<ContactInfoItemProps> = ({ 
  icon, 
  title, 
  content, 
  link 
}) => {
  return (
    <HStack spacing={4} align="flex-start">
      <Box
        p={2}
        borderRadius="md"
        bg="brand.primary.base"
        color="white"
      >
        {icon}
      </Box>
      <VStack align="flex-start" spacing={0}>
        <Text fontWeight="bold">{title}</Text>
        {link ? (
          <a href={link} target="_blank" rel="noopener noreferrer">
            <Text 
              color="gray.700"
              fontWeight="normal"
            >
              {content}
            </Text>
          </a>
        ) : (
          <Text color="gray.700">{content}</Text>
        )}
      </VStack>
    </HStack>
  );
};

export default ContactInfoItemPresentation;